import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { entityProfileTypeLabels } from "@components/entity/constants";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";

export const ApplyCloseEntityLegalTypeCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        unknown
    >) => {
        if (row.original.isClientRow) {
            return <ViewTableCell />;
        }

        const { legalType } = row.original;
        const label =
            legalType !== null
                ? (entityProfileTypeLabels[legalType] ?? legalType)
                : "-";

        return (
            <ViewTableCell>
                <span className="text-secondary">{label}</span>
            </ViewTableCell>
        );
    },
);
